import type { TMerchantCabinetEnvConfig } from '../config/ConfigProvider';
import * as Sentry from '@sentry/react';

export function isLocalhost(hostname?: string): boolean {
  const host =
    (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : ''))
      .toLowerCase()
      .trim();

  return (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host === '0.0.0.0' ||
    host === '::1' ||
    host.endsWith('.localhost')
  );
}

export function shouldEnableSentry(
  environment?: TMerchantCabinetEnvConfig['environment'],
  hostname?: string,
): boolean {
  return environment === 'prod' && !isLocalhost(hostname);
}

export function isSentryInitialized(): boolean {
  try {
    return !!(Sentry as any)?.getCurrentHub?.()?.getClient?.();
  } catch {
    return false;
  }
}
